import { Action, createReducer, on } from '@ngrx/store';
import {
    addRecordSuccess,
    clearDeleteError,
    deleteRecordFail,
    deleteRecordSuccess,
    loadRecordsSuccess,
    updateRecordSuccess
} from './actions';
import { Brand } from '../../../../models/Prodotto';
import { logoutSuccess } from '../../../../core/store/auth/actions';

const initialState: Brand[] = null;

const featureReduce = createReducer(
    initialState,
    on(loadRecordsSuccess, (state, {records}) => records),
    on(addRecordSuccess, (state, {record}) => [record, ...state]),
    on(updateRecordSuccess, (state, {record}) => state.map(item => item.id === record.id ? {...item, ...record} : item)),
    on(deleteRecordSuccess, (state, {id}) => state.filter(item => item.id !== id)),
    on(logoutSuccess, () => initialState),
);

export function reducer (state: Brand[] | null, action?: Action) {
    return featureReduce(state, action);
}

const initialDeleteErrorState: string = null;

const deleteErrorReduce = createReducer(
    initialDeleteErrorState,
    on(deleteRecordFail, (state, {message}) => message),
    on(clearDeleteError, () => initialDeleteErrorState),
    on(deleteRecordSuccess, () => initialDeleteErrorState),
    on(logoutSuccess, () => initialDeleteErrorState),
);

export function deleteErrorReducer (state: string | null, action?: Action) {
    return deleteErrorReduce(state, action);
}
